module.exports = __webpack_public_path__ + "static/media/banner.4f111dcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageLargeModelSecurity/banner.png
// module id = 651
// module chunks = 0